type Title = {
  title: string;
};

type MetaProperty = {
  property: string;
  content: string;
};

type MetaName = {
  name: string;
  content: string;
};

type CanonicalLink = {
  tagName: "link";
  rel: "canonical";
  href: string;
};

type Meta = Title | MetaProperty | MetaName | CanonicalLink;

export const generateMetaTags = ({
  metaTitle = "BLAST.tv - Games, Tournaments, Simulators & News",
  metaDescription = "Discover all things CS, Dota, Rocket League and more. Schedules, brackets, fantasy, simulators and mini-games. Transform your viewing experience, stay updated, and earn rewards.",
  metaImageUrl = "https://assets.blast.tv/social/homepage/og-image.webp",
  seoNoIndex = false,
  canonicalUrls = [],
}: {
  metaTitle?: string;
  metaDescription?: string;
  metaImageUrl?: string;
  seoNoIndex?: boolean;
  canonicalUrls?: string[];
}) => {
  const tags: Meta[] = [];

  tags.push({ title: metaTitle });

  tags.push({ name: "twitter:title", content: metaTitle });

  tags.push({ name: "og:site_name", content: "BLAST.tv" });
  tags.push({ name: "og:title", content: metaTitle });
  tags.push({ name: "og:url", content: "https://blast.tv" });

  // Twitter meta tags used to display the website preview when shared on Twitter
  tags.push({ name: "twitter:card", content: "summary_large_image" });
  tags.push({ name: "twitter:site", content: "@BLASTtv" });
  tags.push({ name: "twitter:creator", content: "@BLASTtv" });

  if (metaDescription) {
    tags.push({ name: "description", content: metaDescription });
    tags.push({ name: "twitter:description", content: metaDescription });
    tags.push({ name: "og:description", content: metaDescription });
  }

  if (metaImageUrl) {
    tags.push({ name: "twitter:image", content: metaImageUrl });
    tags.push({ name: "og:image", content: metaImageUrl });
  }

  if (seoNoIndex) {
    tags.push({ name: "robots", content: "noindex" });
  }

  if (canonicalUrls && canonicalUrls.length > 0) {
    canonicalUrls.forEach((url) => {
      tags.push({
        tagName: "link",
        rel: "canonical",
        href: url,
      });
    });
  }

  return tags;
};
